/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Get information about the server
 * @export
 * @interface ServerInfo
 */
export interface ServerInfo {
	/**
	 *
	 * @type {string}
	 * @memberof ServerInfo
	 */
	cOMMITHASH?: string;
}

/**
 * Check if a given object implements the ServerInfo interface.
 */
export function instanceOfServerInfo(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function ServerInfoFromJSON(json: any): ServerInfo {
	return ServerInfoFromJSONTyped(json, false);
}

export function ServerInfoFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ServerInfo {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		cOMMITHASH: !exists(json, 'COMMIT_HASH') ? undefined : json['COMMIT_HASH'],
	};
}

export function ServerInfoToJSON(value?: ServerInfo | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		COMMIT_HASH: value.cOMMITHASH,
	};
}
